export const MAX_VISIBLE_PRESENCE_AVATARS = 3;
